import {
  DisplayProps,
  display,
  letterSpacing,
  LetterSpacingProps,
  lineHeight,
  LineHeightProps,
  textAlign,
  TextAlignProps,
  SpaceProps,
  WidthProps,
  MinWidthProps,
  MaxWidthProps,
  HeightProps,
  MinHeightProps,
  MaxHeightProps,
  ColorProps,
  FlexProps,
  OrderProps,
  AlignSelfProps,
  space,
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  color,
  flex,
  order,
  alignSelf,
} from 'styled-system';

import { styled } from '../../utils/styled-components';

interface TextProps
  extends DisplayProps,
    SpaceProps,
    WidthProps,
    MinWidthProps,
    MaxWidthProps,
    HeightProps,
    MinHeightProps,
    MaxHeightProps,
    ColorProps,
    FlexProps,
    OrderProps,
    AlignSelfProps,
    TextAlignProps,
    LineHeightProps,
    LetterSpacingProps {}

export const Text = styled.div<TextProps>(
  display,
  space,
  width,
  minWidth,
  maxWidth,
  height,
  minHeight,
  maxHeight,
  color,
  flex,
  order,
  alignSelf,
  textAlign,
  lineHeight,
  letterSpacing,
);

export const Heading45 = styled(Text)`
  font-size: 45px;
  font-weight: 500;
`;

Heading45.defaultProps = {
  color: '#000',
  letterSpacing: '-0.3px',
  lineHeight: '1.07',
};

export const Heading40 = styled(Text)`
  font-size: 40px;
  font-weight: 500;
`;

Heading40.defaultProps = {
  color: '#000',
  letterSpacing: '-1px',
  lineHeight: 1,
};

export const Heading35 = styled(Text)`
  font-size: 35px;
  font-weight: 500;
`;

Heading35.defaultProps = {
  color: '#000',
  letterSpacing: 'normal',
  lineHeight: '1.14',
};

export const Heading28 = styled(Text)`
  font-size: 28px;
  font-weight: 500;
`;

Heading28.defaultProps = {
  color: '#000',
  letterSpacing: 'normal',
  lineHeight: '1.25',
};

export const Heading16 = styled(Text)`
  font-size: 16px;
  font-weight: 500;
`;

Heading16.defaultProps = {
  color: '#000',
  letterSpacing: 'normal',
  lineHeight: '1.2',
};

export const Heading20 = styled(Text)`
  font-size: 20px;
  font-weight: 500;
`;

Heading20.defaultProps = {
  color: '#000',
  letterSpacing: 'normal',
  lineHeight: '1.2',
};

export const Text16 = styled(Text)`
  font-size: 16px;
  font-weight: 500;
`;

Text16.defaultProps = {
  color: '#000',
  letterSpacing: 'normal',
  lineHeight: '1.33',
};

export const Text12 = styled(Text)`
  font-size: 12px;
  font-weight: 500;
`;

Text12.defaultProps = {
  color: '#000',
  letterSpacing: 'normal',
  lineHeight: '1.67',
};

export const Text10 = styled(Text)`
  font-size: 10px;
  font-weight: 500;
`;

Text10.defaultProps = {
  color: '#000',
  letterSpacing: 'normal',
  lineHeight: '2',
};
